import React from 'react';
import Well from '$components/ProductDashboard/Well';
import styles from './styles.scss';

import partnerSrc from './justin.jpg';

const PartnerJustin = () => (
  <Well>
    <div className={styles.layout}>
      <div className={styles.content}>
        <div className={styles.title}>Your licensing partner</div>
        <div className={styles.subtitle}>
          We&apos;re here to help you run an effective and engaging training program.
          Please reach out any time and let us know how we can support you.
        </div>
        <div className={styles.body}>
          <img
            className={styles.pic}
            src={partnerSrc}
            alt="Justin Pincar, Founder and CTO at Achievable"
          />
          <div className={styles.info}>
            <div>Justin Pincar, Founder and CTO</div>
            <div>
              Direct:{' '}
              <a href="tel:415-993-9932" target="_blank" rel="noopener noreferrer">
                415-993-9932
              </a>
            </div>
            <div>
              Email:{' '}
              <a
                href="mailto:justin@achievable.me"
                target="_blank"
                rel="noopener noreferrer"
              >
                justin@achievable.me
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Well>
);

export default PartnerJustin;
